import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Checkbox from 'material-ui/Checkbox';
import { putInterest } from '../../interests-page/actions';

const stylesCheckbox = {
    marginBottom: 16,
};

const onCheckIsDefault = (interestId, action) => (event, isInputChecked = false) => {
    action(interestId, { isDefault: isInputChecked });
};

function InterestsList({ interests, putInterest }) {
    return (
        <div>
            {interests.map(({ _id: id, name, isDefault }) => (
                <Checkbox
                    key={id}
                    defaultChecked={isDefault}
                    label={name}
                    onCheck={onCheckIsDefault(id, putInterest)}
                    style={stylesCheckbox}
                />
            ))}
        </div>
    );
}

InterestsList.defaultProps = {
    interests: [],
};

InterestsList.propTypes = {
    interests: PropTypes.arrayOf(
        PropTypes.shape({
            _id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            isDefault: PropTypes.bool.isRequired,
        }),
    ).isRequired,
    putInterest: PropTypes.func.isRequired,
};

export default connect(
    ({ user }) => ({ interests: user.interests }),
    { putInterest },
)(InterestsList);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/InterestsList.js
 **/